// Single source of truth for the native app store links. Updated when the
// app went live on both stores. Import these everywhere instead of copying
// the URLs so the smart "Get the app" link and the install banner never drift.
export const APPLE_APP_STORE_URL = 'https://apps.apple.com/in/app/bower-founder-os/id6782542980';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.bowerschool.app';

/** Returns 'ios' | 'android' | null (desktop / other). */
export function detectMobilePlatform() {
  if (typeof navigator === 'undefined') return null;
  const ua = navigator.userAgent || '';
  if (/iPad|iPhone|iPod/.test(ua) && !(typeof window !== 'undefined' && window.MSStream)) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return null;
}

/** Store URL for a platform, or null for unknown/desktop. */
export function storeUrlFor(platform) {
  if (platform === 'ios') return APPLE_APP_STORE_URL;
  if (platform === 'android') return GOOGLE_PLAY_URL;
  return null;
}
